import { useTransportMutation } from "@/transport"

const UPLOADED_CONVERSATION_DELETE_RUN_OPERATION = "deleteRun"
const UPLOADED_CONVERSATION_UPDATE_RUN_NOTES_OPERATION = "updateRunNotes"

export function useConversationDeleteRunTransport() {
  return useTransportMutation(UPLOADED_CONVERSATION_DELETE_RUN_OPERATION)
}

export function useConversationUpdateRunNotesTransport() {
  return useTransportMutation(UPLOADED_CONVERSATION_UPDATE_RUN_NOTES_OPERATION)
}
